import React, { useContext } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { PackageOptionView } from 'selectors/cart/cartSelectors'
import { OfferPackageOptionView } from 'selectors/offerPageSelectors'
import LePackageUpgradeColumn from './LePackageUpgradeColumn'
import GeoContext from 'contexts/geoContext'

const UpgradeContainer = styled.div`
  display: flex;
  align-items: stretch;
  gap: ${rem(8)};
  overflow-x: scroll;
  height: 100%;

  > :first-child {
    margin-left: ${rem(24)};
  }

  > :last-child {
    margin-right: ${rem(24)};
  }
`

interface Props {
  packageUpgrade: PackageOptionView;
  selectedPackage: OfferPackageOptionView;
  hasFlightsSelected?: boolean;
  onUpgrade: () => void;
  onNoThanks: () => void;
}

function LePackageUpgradeCardTwoColumnsVariantMobile({
  packageUpgrade,
  selectedPackage,
  hasFlightsSelected,
  onUpgrade,
  onNoThanks,
}: Props) {
  const selectedPackageInclusionsCountV2 = selectedPackage.package.inclusionsV2?.length || 0
  const packageUpgradeInclusionsCountV2 = packageUpgrade.package.inclusionsV2?.length || 0

  const hasMoreInclusionsV2 = packageUpgradeInclusionsCountV2 > selectedPackageInclusionsCountV2
  const isDifferentRoom = packageUpgrade.package.roomType?.id !== selectedPackage?.package.roomType?.id

  const { showTaxExclusivePrices } = useContext(GeoContext)

  const selectedPkgPrice = showTaxExclusivePrices ? selectedPackage.basePrice : selectedPackage.basePrice + (selectedPackage.propertyFees || 0)
  const selectedPkgPriceWithFlights = hasFlightsSelected && selectedPackage.flightPrice && selectedPackage.flightsAvailable ? selectedPkgPrice + selectedPackage.flightPrice : selectedPkgPrice

  const upgradePkgPrice = showTaxExclusivePrices ? packageUpgrade.price : packageUpgrade.price + (packageUpgrade.package.propertyFees || 0)
  const upgradePkgPriceWithFlights = hasFlightsSelected && packageUpgrade.flightPrice && packageUpgrade.flightsAvailable ? upgradePkgPrice + packageUpgrade.flightPrice : upgradePkgPrice

  return <UpgradeContainer>
    <LePackageUpgradeColumn
      pkg={packageUpgrade.package}
      totalValue={upgradePkgPriceWithFlights}
      priceDifference={packageUpgrade.priceDifference}
      hasMoreInclusions={hasMoreInclusionsV2}
      isDifferentRoom={isDifferentRoom}
      onUpgrade={onUpgrade}
    />
    <LePackageUpgradeColumn
      pkg={selectedPackage.package}
      totalValue={selectedPkgPriceWithFlights}
      onNoThanks={onNoThanks}
    />
  </UpgradeContainer>
}

export default LePackageUpgradeCardTwoColumnsVariantMobile
